const AngolaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110746)">
      <path
        d="M0 20C0 8.95437 8.95437 0 20 0C31.0456 0 40 8.95437 40 20C39.1305 20 20 22.6087 20 22.6087L0 20Z"
        fill="#D80027"
      />
      <path d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20" fill="black" />
      <path
        d="M17.2583 15.9072L18.9538 17.1377L18.3077 19.1305L20.0019 17.898L21.6975 19.1285L21.0489 17.1363L22.743 15.9039L20.6481 15.9052L19.9994 13.9131L19.3532 15.9059L17.2583 15.9072Z"
        fill="#FFDA44"
      />
      <path
        d="M25.0005 11.3403C23.4245 10.4304 21.7013 10.001 20.0005 10.0039V12.612C21.2576 12.6098 22.5312 12.927 23.6961 13.5996C27.2256 15.6374 28.4393 20.1668 26.4014 23.6963C24.3637 27.2259 19.8344 28.4395 16.3048 26.4017C15.2765 25.8081 14.4464 25.002 13.8346 24.0717L11.6567 25.5095C12.4846 26.7681 13.6093 27.8577 15.0005 28.6608C19.7758 31.4178 25.9037 29.7759 28.6606 25.0006C31.4177 20.2253 29.7758 14.0974 25.0005 11.3403Z"
        fill="#FFDA44"
      />
      <path
        d="M14.2341 18.2598C13.5427 19.5238 14.0069 21.109 15.2708 21.8004L23.7434 26.4301C23.1672 27.4833 23.4732 28.7652 24.5264 29.3414L26.8151 30.5934C27.8683 31.1696 29.1895 30.7827 29.7656 29.7295L31.0176 27.4409L14.2341 18.2598Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110746">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AngolaSvg;
